export const START_REGISTRATION = 'START_REGISTRATION';
export const SET_REGISTRATION = 'SET_REGISTRATION';
export const GET_REGISTRATION = 'GET_REGISTRATION';
export const STOP_REGISTRATION = 'STOP_REGISTRATION';
export const SUCCESS_REGISTRATION = 'SUCCESS_REGISTRATION';
